import React from 'react';
import Modal from 'react-modal';
import {Navigate} from 'react-router-dom';
import Select from 'react-select';

import swal from 'sweetalert';
import {getCookie} from '../../../inc/cookies';
import config from '../../../inc/config';

export default class ConnectCategoryFieldModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCompleted: true,

      fieldInfo: {
        fieldId: 0,
        listed: 0,
        required: 0,
        sort: 0,
        categoryId: this.props.categoryId
      },

      fields: []
    };
  }

  componentDidMount() {
    this.getCategoryFields();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categoryId !== this.props.categoryId) {
      this.setState({fieldInfo: {...this.state.fieldInfo, categoryId: this.props.categoryId}});
    }
  }

  /* getCategoryFields() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'fields/tr', requestOptions)
    .then(response => response.json())
    .then(responseData => responseData.status === 200 ? this.setState({isLoading: false, fields: responseData.fields}) : swal({dangerMode: true, icon: 'warning', title: 'Hay Aksi', text: responseData.message, buttons: 'Tamam'}).then(() => <Navigate to={'/'} replace={true}></Navigate>), () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Yeniden Dene'}).then(() => this.getCategoryFields()));
  } */

  getCategoryFields() {

    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'fields/tr/', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200:
          this.setState({isLoading: false, fields: responseData.fields})
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/categories'));
        break;
        default:
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(() => this.props.navigate('/'));
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Yeniden Dene'}).then(() => this.getCategoryFields()));
  }

  selectedCategoryFieldOnChange = (selectedCategoryField) => {
    this.setState({fieldInfo: {...this.state.fieldInfo, fieldId: selectedCategoryField.value}});
  };

  listedOnChange = (event) => {
    this.setState({fieldInfo: {...this.state.fieldInfo, listed: event.target.checked ? 1 : 0}});
  }

  requiredOnChange = (event) => {
    this.setState({fieldInfo: {...this.state.fieldInfo, required: event.target.checked ? 1 : 0}});
  }

  saveOnClick = () => {
    let infoMessage = '';

    if(!this.state.fieldInfo.fieldId) {
      infoMessage = "Özellik adı boş geçilemez !";
    }

    if (infoMessage) {
      swal({
        dangerMode: true,
        icon: 'info',
        title: 'Eksik Bilgi',
        text: infoMessage,
        buttons: 'Tamam'
      });
    } else {
      this.props.saveOnClick(this.state.fieldInfo);
      this.setState({fieldInfo: {...this.state.fieldInfo, listed: 0, required: 0, sort: 0}});
    }
  }

  handleKeyPress = (event) => {
    if(event.key === 'Enter') {
      this.saveOnClick();
    }
  }

  render() {

    const selectedCategoryFieldOptions = this.state.fields.map((fieldInfo) => {
      const description = this.state.fields.find((categoryField) => categoryField.id === fieldInfo.id)?.description || '';
      return {
        value: fieldInfo.id,
        label: <><b>{fieldInfo.name}</b> - <span>{description}</span></>,
        search: fieldInfo.name + ' ' + description
      };
    });
    

    return (
      <div className="modal inmodal">
        <div className="modal-dialog">
          <div className="modal-content animated fadeIn">
          <Modal
            isOpen={this.props.isOpen}
            onRequestClose={this.props.onRequestClose}
            style={{
              content : {
                position : 'null',
                top : 'null',
                left : 'null',
                right : 'null',
                bottom : 'null',
                border : 'none',
                background : '#fff',
                padding : 'null',
                maxWidth : '50%',
                minWidth : '350px'
              },
              overlay : {
                position : 'fixed',
                top : 0,
                left : 0,
                right : 0,
                bottom : 0,
                display : 'flex',
                alignItems : 'center',
                justifyContent : 'center',
                backgroundColor : 'rgba(0,0,0,00.1)',
                zIndex:2500
              }
            }}
          >
            <div className={this.state.isCompleted ? "ibox-content no-padding" : "ibox-content sk-loading no-padding"}>
              <div className="sk-spinner sk-spinner-fading-circle">
                <div className="sk-circle1 sk-circle"></div>
                <div className="sk-circle2 sk-circle"></div>
                <div className="sk-circle3 sk-circle"></div>
                <div className="sk-circle4 sk-circle"></div>
                <div className="sk-circle5 sk-circle"></div>
                <div className="sk-circle6 sk-circle"></div>
                <div className="sk-circle7 sk-circle"></div>
                <div className="sk-circle8 sk-circle"></div>
                <div className="sk-circle9 sk-circle"></div>
                <div className="sk-circle10 sk-circle"></div>
                <div className="sk-circle11 sk-circle"></div>
                <div className="sk-circle12 sk-circle"></div>
              </div>
              <div className="modal-header d-block text-center text-darkblue">
                <button className="close" onClick={this.props.onRequestClose}><span>×</span></button>
                <h4 className="modal-title">{this.props.modalTitle}</h4>
                <h5 className="font-normal">{this.props.modalDescription}</h5>
              </div>
              <div className="modal-body text-darkblue">
                <strong>Özel Alan Adı<strong className="text-danger ml-1">*</strong></strong>
                <Select
                  className=" form-input mb-2 mt-1 text-dark"
                  options={selectedCategoryFieldOptions}
                  onChange={this.selectedCategoryFieldOnChange}
                  value={selectedCategoryFieldOptions.find((selectedCategoryFieldOptionInfo) => selectedCategoryFieldOptionInfo.value === this.state.selectedCategoryFieldOptionInfo)}
                  placeholder="Özel Alan Adı"
                  onKeyDown={this.handleKeyPress}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  filterOption={(option, searchText) => option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))}
                  styles={{
                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex:3000
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 3000,
                    }),
                  }}
                />
                <div>
                  <strong className="text-darkblue">Sıralama<strong className="text-danger ml-1">*</strong></strong>
                  <input className="form-control form-input mb-2 mt-1" min="0" onChange={event => this.setState({ fieldInfo: {...this.state.fieldInfo, sort: event.target.value}})} placeholder="Sıralama" type="number" value={this.state.fieldInfo.sort} />
                </div>
                <div className="d-flex mt-4">
                  <strong>Liste öğesi mi?</strong>
                  <div className="d-flex ml-2">
                    <input checked={this.state.fieldInfo.listed === 1} onChange={this.listedOnChange} onKeyDown={this.handleKeyPress} type="checkbox" />
                  </div>
                </div>
                <div className="d-flex mt-4">
                  <strong>Zorunlu Alan</strong>
                  <div className="d-flex ml-2">
                    <input checked={this.state.fieldInfo.required === 1} onChange={this.requiredOnChange} onKeyDown={this.handleKeyPress} type="checkbox" />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-orange" onClick={this.saveOnClick}>Kaydet</button>
              </div>
            </div>
          </Modal>
          </div>
        </div>
      </div>
    )
  }
}
